export const errorStatusTypeMap = {
    '4xx': 'warning',
    '5xx': 'error'
};